// app/src/i18n/locales.js — THE 24-LOCALE REGISTRY (D1-DESIGN §8.1). Pure data: swapping a
// locale is one row here + one messages file. `fallback` is registry DATA (es-AR falls back
// to es-ES by declaration, never by string surgery); `dir` is carried per-locale from day
// one so RTL later is data, not a rework (none of the 24 are RTL today).
//
// ✅ RECONCILED against Daniel's exact 24-locale list (2026-07-05 spec; coordinator fix
// 2026-07-06): the D1 agent's proposed completion had Turkish (tr-TR, not on the list) and
// missed Romanian (ro-RO, on the list) — swapped. tl-PH is the full BCP-47 form of Daniel's
// "tl" (Filipino). tr-TR.draft.json is orphaned — D2a may delete it.

export const LOCALES = [
  { tag: 'en-US', nativeName: 'English (US)', dir: 'ltr' },
  { tag: 'zh-CN', nativeName: '简体中文', dir: 'ltr' },
  { tag: 'zh-TW', nativeName: '繁體中文', dir: 'ltr' },
  { tag: 'ja-JP', nativeName: '日本語', dir: 'ltr' },
  { tag: 'ko-KR', nativeName: '한국어', dir: 'ltr' },
  { tag: 'es-ES', nativeName: 'Español (España)', dir: 'ltr' },
  { tag: 'es-MX', nativeName: 'Español (México)', dir: 'ltr', fallback: 'es-ES' },
  { tag: 'es-AR', nativeName: 'Español (Argentina)', dir: 'ltr', fallback: 'es-ES' },
  { tag: 'pt-PT', nativeName: 'Português (Portugal)', dir: 'ltr' },
  { tag: 'pt-BR', nativeName: 'Português (Brasil)', dir: 'ltr', fallback: 'pt-PT' },
  { tag: 'fr-FR', nativeName: 'Français', dir: 'ltr' },
  { tag: 'de-DE', nativeName: 'Deutsch', dir: 'ltr' },
  { tag: 'it-IT', nativeName: 'Italiano', dir: 'ltr' },
  { tag: 'nl-NL', nativeName: 'Nederlands', dir: 'ltr' },
  { tag: 'pl-PL', nativeName: 'Polski', dir: 'ltr' },
  { tag: 'ro-RO', nativeName: 'Română', dir: 'ltr' },
  { tag: 'ru-RU', nativeName: 'Русский', dir: 'ltr' },
  { tag: 'hi-IN', nativeName: 'हिन्दी', dir: 'ltr' },
  { tag: 'ta-IN', nativeName: 'தமிழ்', dir: 'ltr' },
  { tag: 'th-TH', nativeName: 'ไทย', dir: 'ltr' },
  { tag: 'vi-VN', nativeName: 'Tiếng Việt', dir: 'ltr' },
  { tag: 'id-ID', nativeName: 'Bahasa Indonesia', dir: 'ltr' },
  { tag: 'ms-MY', nativeName: 'Bahasa Melayu', dir: 'ltr' },
  { tag: 'tl-PH', nativeName: 'Filipino', dir: 'ltr' },
];

// the messages loader — Vite code-splits each locale into its own lazy chunk. en-US is the
// authored source; the other 23 ship as *.draft.json (machine drafts, marked by _draft:true
// inside — Daniel reviews the languages he reads; promotion = rename the file).
export async function loadBundle(tag) {
  if (tag === 'en-US') return (await import('./messages/en-US.json')).default;
  return (await import(`./messages/${tag}.draft.json`)).default;
}
